import axiosInstance from 'plugins/axios';
import {
    IResponseCustomer,
    IResponseCustomersCampaigns,
    IResponsePaymentClient,
    IResponseSumaryClient,
} from 'types/customer';
import { IBodyResponse } from 'types/type.global';
import { objectToFormData } from 'utils/helpers';

export const listClients = async (
    params: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get('admin/clients', {
        params,
    });
    return response.data;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteClient = async (id: number): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.delete(`admin/clients/${id}`);
    return response.data;
};

export const getClientInfo = async (
    id: number
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(`admin/clients/${id}`);
    return response.data;
};

export const updateClient = async (
    id: number,
    data: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.put(
        `admin/clients/${id}`,
        objectToFormData({ client: data })
    );
    return response.data;
};

export const createClient = async (
    data: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.post(
        'admin/clients',
        objectToFormData({ client: data })
    );
    return response.data;
};

export const exportClient = async (
    params: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
    const response = await axiosInstance.get('admin/clients/export_data', {
        params,
        responseType: 'blob',
    });

    return response.data;
};

export const getClientDetail = async (
    id: string
): Promise<IBodyResponse<IResponseCustomer>> => {
    const response = await axiosInstance.get(`admin/clients/${id}`);
    return response.data;
};

export const getListCampaignsClient = async (
    clientId: string,
    params: {
        page: number;
        limit: number;
    }
): Promise<IBodyResponse<IResponseCustomersCampaigns>> => {
    const response = await axiosInstance.get(
        `/admin/clients/${clientId}/surveys`,
        {
            params,
        }
    );
    return response.data;
};

export const getListPaymentClient = async (
    clientId: string,
    params: {
        page: number;
    }
): Promise<IBodyResponse<IResponsePaymentClient>> => {
    const response = await axiosInstance.get(
        `/admin/clients/${clientId}/payments`,
        {
            params,
        }
    );
    return response.data;
};

export const getDataSummaryClient = async (
    clientId: string
): Promise<IBodyResponse<IResponseSumaryClient>> => {
    const response = await axiosInstance.get(
        `/admin/clients/${clientId}/overview`
    );
    return response.data;
};
